import * as React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import { FiSettings } from 'react-icons/fi';

import HideUnusedGroupsDropdownItem from './components/HideUnusedGroupsDropdownItem';
import NumberOfDaysDropdownItem from './components/NumberOfDaysDropdownItem';

function EventsTimelineSettingsDropdownComponents(): React.ReactElement {
    return (
        <Dropdown
            trigger={
                <Button
                    circular
                    icon
                    style={{
                        padding: 0,
                        background: 'transparent',
                        boxShadow: 'none',
                        marginTop: 5,
                        marginLeft: 5
                    }}
                >
                    <FiSettings size="24" style={{ verticalAlign: 'middle' }} />
                </Button>
            }
            icon={null}
            direction="left"
            floating
        >
            <Dropdown.Menu>
                <NumberOfDaysDropdownItem text="Day" value={1} />
                <NumberOfDaysDropdownItem text="4 Days" value={4} />
                <NumberOfDaysDropdownItem text="Week" value={7} />
                <NumberOfDaysDropdownItem text="2 Weeks" value={14} />
                <Dropdown.Divider style={{ margin: 0 }} />
                <HideUnusedGroupsDropdownItem />
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default EventsTimelineSettingsDropdownComponents;
